import { render, staticRenderFns } from "./platformCouponReceiveLog.vue?vue&type=template&id=54bcc9a6&scoped=true"
import script from "./platformCouponReceiveLog.vue?vue&type=script&lang=js"
export * from "./platformCouponReceiveLog.vue?vue&type=script&lang=js"
import style0 from "./platformCouponReceiveLog.vue?vue&type=style&index=0&id=54bcc9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bcc9a6",
  null
  
)

export default component.exports